<template>
  <div class="contain-box">
    <div class="company">
      <p class="sub-title">
        {{company}}
        <router-link to="/NewsLists" tag="div" class="more">查看更多</router-link>
      </p>
      <ul class="company-info">
        <li class="info" v-for="(item,index) in companyList" :key="index" @click="goParam(index)">
          <div class="box">
            <img :src="item.titlepic" alt>
            <div class="msg">
              <p class="msg-title">{{item.title}}</p>
              <p class="text">{{item.brief}}</p>
            </div>
            <span></span>
            <div class="date">
              <p
                class="month"
              >{{new Date(parseInt(item.addtime)).getMonth() + 1}}-{{new Date(parseInt(item.addtime)).getDay() + 1}}</p>
              <p class="year">{{new Date(parseInt(item.addtime)).getFullYear()}}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="industry">
      <p class="sub-title">{{industry}}</p>
      <ul class="industry-info">
        <li class="items" v-for="(item,index) in industryList" :key="index">
          <a :href="item['url']" class="msg" target="_blank">{{item["title"]}}</a>
          <p class="odate">{{item["time"].slice(5)}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import api from "@/axios.js";
export default {
  data() {
    return {
      company: "公司",
      industry: "行业",
      companyList: [
        /* {
          titlepic: require("../assets/images/home/advantage01.png"),
          title: "南京步锐捷参加第52届北京特许加盟展",
          brief:
            "南京步锐捷参加第52届北京特许加盟展南京步锐捷参加第52届北京特许加盟展南京步锐捷参加第52届北京特许加盟展"
        },
        {
          titlepic: require("../assets/images/home/advantage01.png"),
          title: "南京步锐捷参加第52届北京特许加盟展",
          brief:
            "南京步锐捷参加第52届北京特许加盟展南京步锐捷参加第52届北京特许加盟展南京步锐捷参加第52届北京特许加盟展"
        },
        {
          titlepic: require("../assets/images/home/advantage01.png"),
          title: "南京步锐捷参加第52届北京特许加盟展",
          brief:
            "南京步锐捷参加第52届北京特许加盟展南京步锐捷参加第52届北京特许加盟展南京步锐捷参加第52届北京特许加盟展"
        },
        {
          titlepic: require("../assets/images/home/advantage01.png"),
          title: "南京步锐捷参加第52届北京特许加盟展",
          brief:
            "南京步锐捷参加第52届北京特许加盟展南京步锐捷参加第52届北京特许加盟展南京步锐捷参加第52届北京特许加盟展"
        } */
      ],
      industryList: [
        {
          title: "2171亿元中国咖啡市场，暴力收割已过时，诸神混战",
          time: "2020-09-09",
          url: "https://www.iyiou.com/p/132557.html"
        },
        {
          title: "1年1.2亿支，冰淇淋才是饮品店最大赢家！",
          time: "2020-09-09",
          url: "https://www.iyiou.com/p/103669.html"
        },
        {
          title: "寻找门店屏幕管理最优解",
          time: "2020-09-09",
          url: "https://www.jianshu.com/p/a638bf763114"
        },
        {
          title: "如何统一进行门店电视管理？",
          time: "2020-08-16",
          url: "https://www.sohu.com/a/413370622_120827318"
        },
        {
          title: "AI+数字标牌，助力打造线下零售个性化",
          time: "2018-06-04",
          url: "http://www.pjtime.com/2018/6/112848268664.shtml"
        },
        {
          title: "数字标牌亟待技术创新，如何创造出更大价值？",
          time: "2018-04-25",
          url: "http://www.pjtime.com/2018/4/351822322398.shtml"
        },
        {
          title: "确保数字标牌吸引观众的五大建议",
          time: "2018-03-27",
          url: "http://www.pjtime.com/2018/3/363247625454.shtml"
        },
        {
          title: "数字标牌广告如何影响消费者行为？",
          time: "2018-03-07",
          url: "http://www.pjtime.com/2018/3/163326202672.shtml"
        },
        {
          title: "“云”概念让数字标牌广告机如虎添翼",
          time: "2018-01-15",
          url: "http://www.ds-360.com/news/2018/1/2018_1_29884.htm"
        }
      ]
    };
  },
  mounted() {
    api.getNewsList({
        pageNum: 0,
        pageSize: 0
      })
      .then(response => {
        console.log(response.data)
        this.companyList = response.data.slice(0, 4);
      });
  },
  methods: {
    goParam(index) {
      this.$router.push({
        name: "NewsDetial",
        params: {
          id: index
        }
      });
    }
  }
};
</script>

<style scoped>
.contain-box {
  width: 1200px;
  font-size: 36px;
  margin: 0 auto;
  margin-top: 65px;
  color: #505050;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
}

.box {
  height: 100%;
  position: relative;
}

.box img {
  width: 154px;
  height: 116px;
}

.company,
.industry {
  width: 534px;
  display: inline-block;
  font-size: 24px;
  box-sizing: border-box;
}

.info {
  width: 100%;
  height: 116px;
  background: #f7f7f7;
  margin: 13px 0;
  cursor: pointer;
}

div.msg {
  width: 368px;
  height: 100%;
  display: inline-block;
  margin-left: 12px;
  vertical-align: middle;
}

.msg-title {
  font-size: 20px;
  text-align: left;
  margin-top: 20px;
}

.text {
  font-size: 14px;
  color: #949494;
  text-align: left;
  margin-top: 20px;
}

.msg-title,
.text {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.box > img {
  float: left;
}

.box > span {
  display: inline-block;
  width: 1px;
  height: 50px;
  background: #b5b5b5;
  position: absolute;
  right: 110px;
  top: 35%;
  display: none;
}

.date {
  position: absolute;
  right: 30px;
  top: 20%;
  display: inline-block;
  color: #949494;
  text-align: center;
  display: none;
}

.month {
  font-size: 36px;
}

.year {
  font-size: 24px;
}

.items {
  height: 56px;
  border-bottom: 1px solid #b5b5b5;
  box-sizing: border-box;
}

.industry {
  float: right;
}

.items > .msg {
  height: 100%;
  line-height: 58px;
  display: inline-block;
  font-size: 16px;
  color: #505050;
  margin-left: 0;
  text-decoration: none;
}

.items > .odate {
  height: 100%;
  line-height: 58px;
  display: inline-block;
  float: right;
  margin-right: 20px;
  font-size: 16px;
  color: #949494;
}

.more {
  width: 120px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  color: #fff;
  background: #f9a310;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  float: right;
}

p.title {
  font-size: 46px;
  text-align: center;
  margin-bottom: 40px;
  line-height: 46px;
}

.sub-title {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/News.vue